import React from 'react';
import Icon from '@/components/ui/AppIcon';
import AppImage from '@/components/ui/AppImage';

interface ProgramCardProps {
  title: string;
  description: string;
  image: string;
  alt: string;
  ageGroup: string;
  duration: string;
  level: string;
  features: string[];
  icon: string;
  onLearnMore: () => void;
}

const ProgramCard = ({
  title,
  description,
  image,
  alt,
  ageGroup,
  duration,
  level,
  features,
  icon,
  onLearnMore
}: ProgramCardProps) => {
  return (
    <div className="bg-card rounded-lg shadow-card hover:shadow-hover transition-all duration-300 overflow-hidden group">
      <div className="relative h-48 overflow-hidden">
        <AppImage
          src={image}
          alt={alt}
          className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" />

      </div>

      <div className="p-6">
        <div className="flex items-center space-x-3 mb-4">
          <div className="flex items-center justify-center w-12 h-12 bg-accent/10 rounded-lg">
            <Icon name={icon as any} size={24} variant="solid" className="text-accent" />
          </div>
          <h3 className="text-xl font-heading font-bold text-primary">{title}</h3>
        </div>

        <p className="text-text-secondary text-sm mb-4 line-clamp-3">{description}</p>

        <div className="flex flex-wrap gap-2 mb-4">
          <span className="px-3 py-1 bg-muted text-text-primary text-xs font-heading font-semibold rounded-full">
            {ageGroup}
          </span>
          <span className="px-3 py-1 bg-muted text-text-primary text-xs font-heading font-semibold rounded-full">
            {duration}
          </span>
          <span className="px-3 py-1 bg-muted text-text-primary text-xs font-heading font-semibold rounded-full">
            {level}
          </span>
        </div>

        <ul className="space-y-2 mb-6">
          {features.slice(0, 3).map((feature, index) =>
          <li key={index} className="flex items-start space-x-2 text-sm text-text-secondary">
              <Icon name="CheckCircleIcon" size={16} variant="solid" className="text-success mt-0.5 flex-shrink-0" />
              <span>{feature}</span>
            </li>
          )}
        </ul>

        <button
          onClick={onLearnMore}
          className="w-full px-4 py-3 bg-primary text-primary-foreground font-heading font-bold text-sm rounded-md hover:bg-primary/90 transition-all duration-300 flex items-center justify-center space-x-2">

          <span>Learn More</span>
          <Icon name="ArrowRightIcon" size={16} variant="outline" />
        </button>
      </div>
    </div>);

};

export default ProgramCard;